/**
 * Logo — Canvas 워드마크 + 좌우 거울대칭 잔물결 (브랜드 자산).
 *
 * 색은 디자인 토큰(logoInk / logoWave)을 따른다. design.md §1c 참조.
 * - 글자: 다크 슬레이트 그레이(어두운 배경에선 inverse 로 반전), 대문자 시작 "Canvas"
 * - 물결: 블루, 좌우 거울 대칭 8굽이(C1 연속) 잔물결 path
 *
 * props:
 *   height   — 워드마크 글자 높이(px). 나머지는 비례 스케일. 기본 40.
 *   inverse  — 어두운 배경용 글자 반전색.
 *   wave     — 물결 표시 여부(기본 true).
 *   style    — 래퍼 추가 스타일.
 */
import { logoInk, logoWave, logoInkInverse } from '../theme/tokens';

// 좌우 거울대칭(중심 x=95) 8굽이 잔물결. viewBox 0 0 190 30.
const WAVE_D =
  'M5 15 C 12.5 7, 20 7, 27.5 15 C 35 23, 42.5 23, 50 15 C 57.5 7, 65 7, 72.5 15 C 80 23, 87.5 23, 95 15 C 102.5 7, 110 7, 117.5 15 C 125 23, 132.5 23, 140 15 C 147.5 7, 155 7, 162.5 15 C 170 23, 177.5 23, 185 15';

// 물결 굵기(viewBox 단위 상수) — 렌더 두께는 waveH 에 비례해 자동 스케일.
const WAVE_STROKE_VB = 8.5;

export default function Logo({ height = 40, inverse = false, wave = true, style }) {
  const ink = inverse ? logoInkInverse : logoInk;
  const waveW = height * 3.85;                        // 물결 너비(Canvas 글자폭에 맞춤)
  const waveH = Math.max(8, height * 0.34);           // 물결 높이

  return (
    <span
      aria-label="Canvas"
      style={{
        display: 'inline-flex', flexDirection: 'column', alignItems: 'center',
        gap: Math.round(height * 0.08), lineHeight: 0.9, userSelect: 'none', ...style,
      }}
    >
      <span
        style={{
          fontFamily: '"Arial Black", "Helvetica Neue", Helvetica, Arial, sans-serif',
          fontWeight: 900, fontSize: height, letterSpacing: -height * 0.025, color: ink,
        }}
      >
        Canvas
      </span>
      {wave && (
        <svg
          width={waveW} height={waveH} viewBox="0 0 190 30" fill="none"
          preserveAspectRatio="none"
          style={{ overflow: 'visible', display: 'block' }}
        >
          <path d={WAVE_D} stroke={logoWave} strokeWidth={WAVE_STROKE_VB} strokeLinecap="round" />
        </svg>
      )}
    </span>
  );
}
